import { Atom, atom } from 'jotai'
import { keyBy } from 'lodash'

export interface User {
  name: string
  email: string
  wechatUserId: string
  departments: { id: number; name: string }[]
  departmentIds: number[]
  avatar: string
  permissions: { [key: string]: any }
}

export interface UserInfo extends User {
  isSuperAdmin: boolean
  isMiniIPDCore: boolean
  roles: { email: string; role: string }[]
}

export const userInfoAtom: Atom<UserInfo> = atom(null as any)

export const usersAtom: Atom<User[]> = atom([])

export const usersMapAtom: Atom<{ [email: string]: User }> = atom((get) => keyBy(get(usersAtom), 'email'))
